import React, { Component } from "react";
import { Button } from "@material-ui/core";
import "./ImgButton.css"

export default class ImgButton extends Component {

    render() {
        return (
            <div className="ImgButton">
                <Button
                    style={{
                        padding: "0 0"
                    }}
                    {...this.props}
                >
                    <img 
                        className="ImgButton-image"
                        src={this.props.src} 
                        alt={this.props.alt}
                    />
                    <div className="ImgButton-content">
                        {this.props.children}
                    </div>
                </Button>
            </div>
        );
    }

}